export default __webpack_public_path__ + "static/media/img_declaration_promise_quote.7642a28a.svg";